import { useSuspenseQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { dashboardQuery } from "../api/queries";
import { indexMediaById } from "../lib/media-views";
import { toConnectionView } from "../lib/shell-views";

/**
 * The dashboard as every screen reads it.
 *
 * The router loads it before the first paint, so here it is always there; a screen never
 * has to decide what to show while it is missing.
 */
export function usePanel() {
  const { data } = useSuspenseQuery(dashboardQuery);
  const mediaById = useMemo(() => indexMediaById(data.media), [data.media]);
  const connection = useMemo(() => toConnectionView(data.config, data.profile), [data.config, data.profile]);
  return { ...data, mediaById, connection };
}
